import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Kontrolltermin } from '../../services/kontrolltermin.service';
import { StatusViewComponent } from '../interfaces/status-view.interface';

@Component({
  template: '' // Abstract component
})
export abstract class BaseStatusViewComponent implements StatusViewComponent, OnInit {
  @Input() kontrolltermin!: Kontrolltermin;
  @Input() isEditMode: boolean = false;
  @Output() statusChanged = new EventEmitter<any>();
  
  // Common properties
  isLoading = false;
  isSaving = false;
  form: FormGroup;
  
  constructor(protected formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({});
  }
  
  ngOnInit(): void {
    console.log(`🎯 ${this.getStatusTitle()} Component Loaded`);
    console.log('📊 Kontrolltermin:', this.kontrolltermin);
    console.log('📋 Edit Mode:', this.isEditMode);
    console.log('🔧 Available Actions:', this.getAvailableActions());
    
    this.setupForm();
  }
  
  // Abstract methods to be implemented by each status
  abstract getStatusTitle(): string;
  abstract getAvailableActions(): string[];
  abstract getFormFields(): any[];
  abstract onSave(): void;
  abstract onCancel(): void;
  abstract onStatusChange(newStatus: string): void;
  
  // Common methods
  protected setupForm(): void {
    // Common form setup logic
    console.log('🔧 Setting up form for', this.getStatusTitle());
  }
  
  protected emitStatusChange(newStatus: string): void {
    console.log(`🔄 Status change from ${this.getStatusTitle()} to ${newStatus}`);
    this.statusChanged.emit({
      newStatus,
      kontrolltermin: this.kontrolltermin
    });
  }
  
  protected logAction(action: string): void {
    console.log(`🎬 ${this.getStatusTitle()}: ${action} action triggered`);
  }
  
  // Common helper methods
  getTechnikerName(techniker: any): string {
    if (!techniker) return 'Nicht zugewiesen';
    return `${techniker.vorname || ''} ${techniker.nachname || ''}`.trim() || 'Nicht zugewiesen';
  }
}
